module.exports = __webpack_public_path__ + "img/91.aaa18c8d.png";